// Chat History Manager
// Handles persistence, filtering, and manipulation of chat history

import { MessageType } from '../types/messages';

const CHAT_TTL = 5 * 60 * 1000; // 5 minutes

// A tool call is recorded before the tool runs and its result only after, so a
// snapshot taken in that window ends on an unpaired call. Restored verbatim, the
// API rejects every later request in the conversation - the chat is dead until
// the history expires. Trimming the tail keeps the rest of the turn, which is
// what the user actually wants back after a reload.
const withoutDanglingToolCalls = (messages) => {
  let end = messages.length;
  while (end > 0 && messages[end - 1].type === MessageType.TOOL_CALL) end--;
  return end === messages.length ? messages : messages.slice(0, end);
};

export class HistoryManager {
  constructor(domain, dbRef) {
    this.domain = domain;
    this.dbRef = dbRef;
    this.key = `__chat-${domain}`;
  }

  async load() {
    try {
      const data = await this.dbRef.current.get('files', this.key);
      if (!data) return [];

      const age = Date.now() - data.timestamp;
      if (age < CHAT_TTL) {
        return data.messages;
      }

      await this.clear();
      return [];
    } catch {
      return [];
    }
  }

  async save(messages) {
    try {
      await this.dbRef.current.put('files', {
        timestamp: Date.now(),
        messages: withoutDanglingToolCalls(messages)
      }, this.key);
    } catch {
      // Ignore save errors
    }
  }

  async clear() {
    try {
      await this.dbRef.current.delete('files', this.key);
    } catch {
      // Ignore clear errors
    }
  }
}
